export const CATEGORY_COLOR_MAP = [
  '#348EF6',
  '#FFA826',
  '#33C173',
  '#7F58F0',
  '#FD5CAD',
  '#B669BF',
  '#124345',
  '#373421',
]

export const CATEGORY_HOVER_COLOR_MAP = [
  '#2271CC',
  '#FF9C10',
  '#2FB26A',
  '#714FD6',
  '#E3539B',
  '#9E5BA6',
  '#0D3233',
  '#302E1D',
]

export const CATEGORY_ACTIVE_COLOR_MAP = [
  '#1162C0',
  '#f58f00',
  '#0A8041',
  '#6445BD',
  '#C9498A',
  '#864D8C',
  '#0B2A2B',
  '#262417',
]

export const CATEGORY_BACKGROUND_COLOR_MAP = [
  '#ECF4FE',
  '#FFF7EA',
  '#EBF9F1',
  '#F1F0F9',
  '#FFF5FA',
  '#F4F1F5',
  '#F3F9F9',
  '#FFFCE5',
]

export const CATEGORY_ANNOTATION_MAP = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H',
]

export const CATEGORY_ANNOTATION_COLOR_MAP = [
  '#1162C0',
  '#A35F21',
  '#0A8041',
  '#6445BD',
  '#CC4A8B',
  '#794680',
  '#124345',
  '#373421',
]

export const CATEGORY_NAME_LENGTH = 40
export const CATEGORY_OPTION_LENGTH = 150
